import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import ConfirmationModal from './ConfirmationModal';

function HistoryDetailModal({ isOpen, onClose, historyItem, onEdit, onDelete }) {
  const { t } = useTranslation();
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false
  });
  if (!historyItem) return null;

  const getStatusEmoji = (status) => {
    switch (status) {
      case 'SAFE': return '✅';
      case 'UNSAFE': return '❌';
      case 'CAUTION': return '⚠️';
      default: return '❓';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'SAFE': return '#28a745';
      case 'UNSAFE': return '#dc3545';
      case 'CAUTION': return '#ffc107';
      default: return '#6c757d';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`📜 ${historyItem.foodName}`}>
      <div className="history-detail">
        <div className="detail-section">
          <div className="detail-badge" style={{ backgroundColor: getStatusColor(historyItem.safetyStatus) + '20', borderColor: getStatusColor(historyItem.safetyStatus) }}>
            <span className="detail-badge-icon">{getStatusEmoji(historyItem.safetyStatus)}</span>
            <span className="detail-badge-text">{historyItem.safetyStatus}</span>
          </div>
        </div>

        <div className="detail-section">
          <h3>🌍 {t('history.detail.culture')}</h3>
          <p className="detail-value">{historyItem.culture || 'N/A'}</p>
        </div>

        <div className="detail-section">
          <h3>👤 {t('history.detail.userId')}</h3>
          <p className="detail-value">{historyItem.userId || 'N/A'}</p>
        </div>

        <div className="detail-section">
          <h3>🕐 {t('history.detail.checkedAt')}</h3>
          <p className="detail-value">{formatDate(historyItem.checkedAt)}</p>
        </div>

        {historyItem.message && (
          <div className="detail-section">
            <h3>💬 {t('history.detail.message')}</h3>
            <p className="detail-value">{historyItem.message}</p>
          </div>
        )}

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            {t('history.detail.close')}
          </button>
          <button className="btn-edit-modal" onClick={() => onEdit(historyItem)}>
            ✏️ {t('history.detail.edit')}
          </button>
          <button className="btn-delete-modal" onClick={() => {
            setConfirmModal({ isOpen: true });
          }}>
            🗑️ {t('history.detail.delete')}
          </button>
        </div>
      </div>

      <ConfirmationModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal({ isOpen: false })}
        onConfirm={() => {
          onDelete(historyItem.id);
          onClose();
          setConfirmModal({ isOpen: false });
        }}
        title={t('history.detail.deleteTitle')}
        message={t('history.detail.deleteMessage')}
        type="warning"
        confirmText={t('common.delete')}
        cancelText={t('common.cancel')}
      />
    </Modal>
  );
}

export default HistoryDetailModal;
















